<div>
  <form [formGroup]="profileForm">
    <section class="w-full px-3 lg:w-4/5 lg:px-0">
      <div class="mb-6 flex items-center">
        <div class="mr-4 h-1 w-6 bg-primary-md-dark lg:w-12"></div>
        <div class="text-xl font-medium text-primary-darkest lg:text-3xl">
          Biodata
        </div>
      </div>
      <div>
        <div class="mb-10 block items-center gap-x-6 lg:flex">
          <div>
            <img
              class="mx-auto mb-3 h-28 w-28 flex-none rounded-full"
              [src]="
                user?.propic_path
                  ? user?.propic_path
                  : 'assets/images/default-user.png'
              "
              alt="" />
          </div>
          <div class="">
            <div class="flex justify-start">
              <label
                class="mr-2 w-full rounded-md bg-primary-md-dark py-2 px-3 text-sm text-white transition duration-500 hover:-translate-y-1 lg:w-fit"
                [ngClass]="{ 'opacity-25': loadingPhotoProfile }">
                <input
                  type="file"
                  class="hidden"
                  [disabled]="loadingPhotoProfile"
                  (change)="onImageChangeFromFile($event)" />
                Upload Foto
                <fa-icon
                  *ngIf="loadingPhotoProfile"
                  class="load-icon"
                  [icon]="faSpinner"
                  [spin]="true"></fa-icon>
              </label>
            </div>
            <p
              class="mt-2 text-center text-sm text-primary-darkest/70 lg:text-start">
              Please upload with JPG or PNG format and file size less than 2MB
            </p>
          </div>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-2">
        <div class="col-span-12 lg:col-span-7">
          <div class="relative">
            <input
              type="text"
              placeholder="Full Name"
              class="relative w-full rounded-md border border-primary-dark px-3 py-2 text-primary-darkest outline-none"
              formControlName="name" />
            <label
              for="name"
              class="absolute left-2 -top-2 bg-white px-1 text-xs text-primary-md-dark opacity-100">
              Full Name</label
            >
          </div>
        </div>
        <div class="col-span-12 mt-3 lg:col-span-5 lg:mt-0">
          <div class="relative">
            <div
              class="relative w-full rounded-md bg-white text-primary-darkest outline-none">
              <p-dropdown
                class="w-full"
                [options]="gender"
                optionValue="value"
                formControlName="gender"
                optionLabel="name"></p-dropdown>
            </div>
            <label
              for="name"
              class="absolute left-2 -top-2 w-fit bg-white px-1 text-xs text-primary-md-dark opacity-100"
              >Gender</label
            >
          </div>
        </div>
      </div>
      <div class="mt-4 mb-0 text-sm text-primary-md-dark lg:mb-4">
        Date of Birth
      </div>
      <div class="grid grid-cols-12 gap-2">
        <div class="col-span-12 py-1 lg:col-span-4">
          <p-dropdown
            class=""
            [options]="date"
            optionValue="value"
            formControlName="date_of_birth_day"
            placeholder="Date"
            optionLabel="name"></p-dropdown>
        </div>
        <div class="col-span-12 py-1 lg:col-span-4">
          <p-dropdown
            [options]="month"
            optionValue="value"
            formControlName="date_of_birth_month"
            placeholder="Month"
            optionLabel="name"></p-dropdown>
        </div>
        <div class="col-span-12 py-1 lg:col-span-4">
          <p-dropdown
            [options]="year"
            optionValue="value"
            formControlName="date_of_birth_year"
            placeholder="Year"
            optionLabel="name"></p-dropdown>
        </div>
      </div>
      <div>
        <button
          (click)="updateProfile()"
          type="submit"
          class="mt-5 w-full rounded-md bg-primary-md-dark px-3 py-2 text-center text-sm text-white transition duration-500 hover:-translate-y-1 lg:w-fit"
          [disabled]="loadingProfile"
          [ngClass]="{ 'opacity-25': loadingProfile }">
          <span class="btn-label">Update Profile</span>
          <fa-icon
            *ngIf="loadingProfile"
            class="load-icon"
            [icon]="faSpinner"
            [spin]="true"></fa-icon>
        </button>
      </div>
    </section>
  </form>

  <section class="my-12 w-full px-3 lg:my-24 lg:w-4/5 lg:px-0">
    <div class="mb-6 flex items-center">
      <div class="mr-4 h-1 w-6 bg-primary-md-dark lg:w-12"></div>
      <div class="text-xl font-medium text-primary-darkest lg:text-3xl">
        My Address
      </div>
    </div>
    <div class="hidden lg:block">
      <div class="flex items-center justify-between">
        <div class="relative flex-1 items-center">
          <div class="relative w-72">
            <input
              type="text"
              placeholder="Find Address"
              class="relative w-full rounded-md border border-primary-dark px-3 py-2 text-sm outline-none" />
            <fa-icon
              class="fa-sm absolute top-2/4 right-3 -translate-y-2/4 text-primary-md-dark"
              [icon]="faMagnifyingGlass"></fa-icon>
          </div>
        </div>

        <button
          type="button"
          (click)="onAddAddress()"
          class="rounded-md bg-primary-md-dark px-3 py-2 text-sm text-white transition duration-500 hover:-translate-y-1">
          <span><fa-icon [icon]="faPlus"></fa-icon></span> Add New Address
        </button>
      </div>
    </div>
    <div class="hidden lg:block">
      <div class="mt-6 rounded-md border border-primary-main">
        <table class="w-full border-collapse border-hidden">
          <thead class="bg-primary-lightest">
            <tr>
              <th class="w-1/6 text-base font-normal text-primary-darkest/50">
                Receiver
              </th>
              <th
                class="w-3/5 text-center text-base font-normal text-primary-darkest/50">
                Address
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody *ngFor="let address of addresses">
            <tr>
              <td class="p-3">
                <b class="text-sm text-primary-darkest">{{
                  address.receiver_name
                }}</b>
                <br />{{ address.phone_no }}
              </td>
              <td
                class="border-b border-b-primary-light p-3 text-center text-sm text-primary-darkest">
                {{ address.address }}
              </td>
              <td
                class="border-b border-b-primary-light p-3 text-sm text-primary-darkest">
                <div class="w-full text-center">
                  <button
                    (click)="onEditAddress(address)"
                    class="mr-3 w-7 rounded-md border border-primary-darkest bg-white py-[3px] px-[6px] text-center outline-none transition duration-500 hover:-translate-y-1 hover:bg-primary-darkest hover:text-white">
                    <fa-icon class="fa-sm" [icon]="faPenToSquare"></fa-icon>
                  </button>
                  <button
                    (click)="removeAddress(address.id)"
                    class="w-7 rounded-md border border-primary-darkest bg-white py-[3px] px-[6px] text-center outline-none transition duration-500 hover:-translate-y-1 hover:bg-primary-darkest hover:text-white">
                    <fa-icon class="fa-sm" [icon]="faTrash"></fa-icon>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!--mobile ver-->
    <div class="block lg:hidden">
      <div class="mb-4">
        <div
          class="relative cursor-pointer rounded-lg border border-primary-dark p-3"
          *ngFor="let address of addresses">
          <div class="text-sm font-bold text-primary-md-dark">
            {{ address.receiver_name }}
          </div>
          <div class="text-sm">{{ address.phone_no }}</div>
          <div class="text-sm">{{ address.address }}</div>
          <div class="mt-1 text-right">
            <div class="w-full text-right">
              <button
                (click)="onEditAddress(address)"
                class="relative mr-3 rounded-md border border-white bg-white py-[3px] px-[6px] text-sm text-primary-md-dark transition duration-500 backdrop:outline-none hover:-translate-y-1 hover:bg-primary-darkest hover:text-white">
                <fa-icon class="fa-sm" [icon]="faPenToSquare"></fa-icon> Edit
                Addres
              </button>
              <button
                (click)="removeAddress(address.id)"
                class="relative rounded-md border border-white bg-white py-[3px] px-[6px] text-sm text-primary-md-dark transition duration-500 backdrop:outline-none hover:-translate-y-1 hover:bg-primary-darkest hover:text-white">
                <fa-icon class="fa-sm mr-1" [icon]="faTrash"></fa-icon>Remove
              </button>
            </div>
          </div>
        </div>
        <button
          (click)="onAddAddress()"
          class="mt-5 w-full rounded-md bg-primary-md-dark px-3 py-2 text-center text-sm text-white transition duration-500 hover:-translate-y-1 lg:w-fit">
          Add Adress
        </button>
      </div>
    </div>
  </section>

  <section class="mt-12 w-full px-3 lg:my-24 lg:w-2/4 lg:px-0">
    <div>
      <div class="mb-6 flex items-center">
        <div class="mr-4 h-1 w-6 bg-primary-md-dark lg:w-12"></div>
        <div class="text-xl font-medium text-primary-darkest lg:text-3xl">
          Change Password
        </div>
      </div>
      <form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()">
        <div class="relative mb-6">
          <input
            #oldPassword
            id="old_password"
            formControlName="old_password"
            type="password"
            placeholder="Old Password"
            class="h relative h-10 w-full rounded-md border border-primary-dark bg-white py-2 px-3 outline-none" />
          <button
            type="button"
            class="absolute top-1/2 right-3 -translate-y-1/2"
            (click)="
              oldPassword.type =
                oldPassword.type === 'password' ? 'text' : 'password'
            ">
            <fa-icon
              class="text-primary-dark"
              [icon]="
                oldPassword.type === 'password' ? faEyeSlash : faEye
              "></fa-icon>
          </button>
        </div>
        <div class="relative mb-6">
          <input
            #newPassword
            id="new_password"
            formControlName="new_password"
            type="password"
            placeholder="New Password"
            class="h relative h-10 w-full rounded-md border border-primary-dark bg-white py-2 px-3 outline-none" />
          <button
            type="button"
            class="absolute top-1/2 right-3 -translate-y-1/2"
            (click)="
              newPassword.type =
                newPassword.type === 'password' ? 'text' : 'password'
            ">
            <fa-icon
              class="text-primary-dark"
              [icon]="
                newPassword.type === 'password' ? faEyeSlash : faEye
              "></fa-icon>
          </button>
        </div>
        <div class="relative mb-6">
          <input
            #retypeNewPassword
            id="retype_new_password"
            formControlName="new_password_confirmation"
            type="password"
            placeholder="Retype New Password"
            class="h relative h-10 w-full rounded-md border border-primary-dark bg-white py-2 px-3 outline-none" />
          <button
            type="button"
            class="absolute top-1/2 right-3 -translate-y-1/2"
            (click)="
              retypeNewPassword.type =
                retypeNewPassword.type === 'password' ? 'text' : 'password'
            ">
            <fa-icon
              class="text-primary-dark"
              [icon]="
                retypeNewPassword.type === 'password' ? faEyeSlash : faEye
              "></fa-icon>
          </button>
        </div>
        <button
          (click)="changePassword()"
          type="submit"
          class="w-full rounded-md bg-primary-md-dark px-3 py-2 text-sm text-white transition duration-500 hover:-translate-y-1 lg:w-fit"
          [disabled]="loading"
          [ngClass]="{ 'opacity-25': loading }">
          <span class="btn-label">Change Password</span>
          <fa-icon
            *ngIf="loading"
            class="load-icon"
            [icon]="faSpinner"
            [spin]="true"></fa-icon>
        </button>
      </form>
    </div>
  </section>
</div>
